import {API_BASE} from "./reports";
import buildHeaders from './fetchHeaders';

export async function getDocumentContent(documentId, signal, user) {
    // Build query params and include `user` when provided. Accepts a string or an object with uid/id/email.
    const params = new URLSearchParams();
    if (user) params.append('userId', user.uid);

    const url = `${API_BASE}/documents/${documentId}${params.toString() ? `?${params.toString()}` : ''}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: buildHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }),
        signal,
    });

    if (!response.ok) {
        let message = 'Failed to fetch document content';
        try {
            const errText = await response.text();
            if (errText) message += `: ${errText}`;
        } catch (_) {
        }
        throw new Error(message);
    }

    const data = await response.json();
    return data;
}

// Get segments with raw HTML for a document
export async function getDocumentSegmentsWithHtml(documentId, signal) {
    const url = `${API_BASE}/segments?docId=${documentId}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: buildHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }),
        signal,
    });

    if (!response.ok) {
        let message = 'Failed to fetch document segments';
        try {
            const errText = await response.text();
            if (errText) message += `: ${errText}`;
        } catch (_) {
        }
        throw new Error(message);
    }

    const data = await response.json();
    return data;
}

// Post feedback for a document (score is 0..1, or null for unverified)
export async function postDocumentFeedback(documentId, {feedbackId, userId, score}) {
    const url = `${API_BASE}/documents/${documentId}/feedback`;

    const response = await fetch(url, {
        method: 'POST',
        headers: buildHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }),
        body: JSON.stringify({feedbackId, userId, score}),
    });

    if (!response.ok) {
        let message = 'Failed to post feedback';
        try {
            const errText = await response.text();
            if (errText) message += `: ${errText}`;
        } catch (_) {
        }
        throw new Error(message);
    }

    try {
        return await response.json();
    } catch (_) {
        return null;
    }
}
